import React, { useEffect, useState } from 'react';
import { Storage } from 'aws-amplify';
import { Avatar } from '@mui/material';
import getSentenceInitials from '../common/utils/getSentenceInitials';

const PAIV_DEFAULT_IMG = '/images/default-avatar.png';

const UserProfilePicture = ({ imageName, size = 60, initials = '' }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Check if it's paivbot by checking if initials contains 'paiv' (case insensitive)
  const isPaivbot = initials?.toLowerCase().match(/paiv|admin-paiv/) !== null;

  const getMedia = async () => {
    try {
      setIsLoading(true);
      if (imageName) {
        const url = await Storage.get(imageName);
        setImageUrl(url);
      } else {
        // Use default image if it's paivbot
        if (isPaivbot) {
          setImageUrl(PAIV_DEFAULT_IMG);
        } else {
          setImageUrl('');
        }
      }
    } catch (err) {
      // Use default image if it's paivbot
      if (isPaivbot) {
        setImageUrl(PAIV_DEFAULT_IMG);
      } else {
        setImageUrl('');
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getMedia();
  }, [imageName, initials]);

  if (isLoading) return null;

  return (
    <Avatar
      src={imageUrl}
      alt="User Profile"
      sx={{
        height: size,
        width: size,
        fontSize: size / 2,
      }}
    >
      {/* Don't show initials for paivbot */}
      {initials && !isPaivbot ? getSentenceInitials(initials) : ''}
    </Avatar>
  );
};

export default UserProfilePicture;
